/**
  equals	The value must be exactly equal.
  not_equals	The query will return all documents where the value is not equal.
  exists	Only return documents where the value either exists (true) or does not exist (false).
  greater_than	For numeric or date-based fields.
  greater_than_equal	For numeric or date-based fields.
  less_than	For numeric or date-based fields.
  less_than_equal	For numeric or date-based fields.
  like	Case-insensitive string must be present. If string of words, all words must be present, in any order.
  contains	Must contain the value entered, case-insensitive.
  in	The value must be found within the provided comma-delimited list of values.
  not_in	The value must NOT be within the provided comma-delimited list of values.
  all	The value must contain all values provided in the comma-delimited list.
  near	For distance related to a point field comma separated as <longitude>, <latitude>, <maxDistance in meters (nullable)>, <minDistance in meters (nullable)>.
  */

export type Operator =
  | 'equals'
  | 'not_equals'
  | 'exists'
  | 'greater_than'
  | 'greater_than_equal'
  | 'less_than'
  | 'less_than_equal'
  | 'like'
  | 'contains'
  | 'in'
  | 'not_in'
  | 'all'
  | 'near';

export type WhereField = {
  [key in Operator]?: unknown
};

export type WhereBase = {
  [key: string]: WhereField | Where[];
};

export type WhereAndOr = {
  or?: Where[];
  and?: Where[];
};

export type Where = WhereBase & WhereAndOr;

export type QueryParams = {
  depth?: number;
  draft?: boolean;
  // 'fallback-locale'?: string;
  // 'joins'?: string;
  limit?: number;
  locale?: string;
  market?: string;
  page?: number;
  pagination?: boolean;
  // 'populate'?: string;
  // 'select'?: string;
  richText?: boolean;
  sort?: string;
  where?: Where;
};

export type GlobalQueryParams = {
  depth?: number;
  draft?: boolean;
  locale?: string;
  market?: string;
  richText?: boolean;
};

/*
depth - automatically populates relationships and uploads
fallback-locale - specifies a fallback locale if no locale value exists
joins - specifies the custom request for each join field by name of the field
limit - limits the number of documents returned
locale - retrieves document(s) in a specific locale
page - specifies which page to get documents from when used with a limit
populate - specifies which fields to include to the result from populated documents
select - specifies which fields to include to the result
sort - specifies the field(s) to use to sort the returned documents by
where - specifies advanced filters to use to query documents
*/
